import React from "react";
import { connect } from "react-redux";

import withStyles from "@material-ui/styles/withStyles";

import {
  Show,
  ShowCard,
  MultiCardShowLayout,
  ReferenceField,
  FunctionField,
  TextField,
  RestMethods,
  PageFooter,
  EditButton,
  BackButton,
} from "jazasoft";

import Table from "jazasoft/lib/mui/components/Table";

import { dataProvider } from "../../App";
import { Role } from "../../utils/types";

const FormFooter = ({ roles, ...props }) => (
  <PageFooter style={{ paddingLeft: "1em" }}>
    {roles && roles.includes(Role.MASTER) && <EditButton variant="contained" color="primary" style={{ marginRight: "1em" }} {...props} />}
    <BackButton variant="contained" color="default" />
  </PageFooter>
);

const fieldOptions = (sm) => ({
  xs: 12,
  sm,
  fullWidth: true,
});

const styles = (theme) => ({
  elavation1: {
    boxShadow: theme.shadows[1],
  },
  contentMargin: {
    margin: "1em",
  },
  table: {
    width: 650,
  },
});

const columns = [
  {
    title: "Resource",
    dataKey: "resourceName",
  },
  {
    title: "scopes",
    dataKey: "scopes",
  },
  {
    title: "Operations",
    dataKey: "actions",
  },
];

class RoleView extends React.Component {
  state = {
    config: {},
  };

  componentDidMount() {
    this.fetchConfigAsync();
  }

  fetchConfigAsync = async () => {
    const options = {
      url: "permissions/configs",
      method: "get",
    };
    try {
      const response = await dataProvider(RestMethods.CUSTOM, null, options);
      this.setState({ config: response.data });
    } catch (e) {
      console.log(e);
    }
  };
  render() {
    const { classes, dispatch, role, roles, ...props } = this.props;

    const permissions = (role && role.app && this.state.config[role.app.appId]) || [];
    const permissionKeys = permissions.filter((p) => p.type === "PER_ROLE");
    return (
      <Show cardWrapper={false} {...props}>
        <MultiCardShowLayout footer={<FormFooter roles={roles} />}>
          <ShowCard title="Basic Info">
            <TextField source="name" {...fieldOptions(3)} />
            <TextField source="roleId" {...fieldOptions(3)} />
            <ReferenceField source="appId" reference="apps" {...fieldOptions(3)}>
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField source="tenantId" reference="tenants" allowEmpty {...fieldOptions(3)}>
              <TextField source="name" />
            </ReferenceField>
            <FunctionField label="Default" render={(record) => (record.isDefault === true ? "Yes" : "No")} {...fieldOptions(3)} />
            <TextField source="desc" {...fieldOptions(3)} />
            {permissionKeys.map((permission, idx) => (
              <FunctionField
                key={idx}
                label={permission.name}
                render={(record) =>
                  record.permissionList &&
                  record.permissionList
                    .filter((p) => p.key === permission.key)
                    .map((p) => p.name)
                    .join(", ")
                }
                {...fieldOptions(6)}
              />
            ))}
          </ShowCard>

          <ShowCard
            title="Privilege"
            content={({ record = {} }) => {
              return (
                <div>
                  <Table
                    columns={columns}
                    rows={record.resourceList ? record.resourceList.sort((a, b) => (a.resourceName < b.resourceName ? -1 : 1)) : []}
                  />
                </div>
              );
            }}
          />
        </MultiCardShowLayout>
      </Show>
    );
  }
}

export default connect((state, props) => ({
  role: state.jazasoft.resources["roles"] && state.jazasoft.resources["roles"].data && state.jazasoft.resources["roles"].data[props.id],
}))(withStyles(styles)(RoleView));
